import React from "react";

import {withRouter} from '../../shim/withRouter';
import DefaultLink from './DefaultLink'

export default withRouter(DefaultLink)
